import React, { useRef } from 'react';
import GoogleMapReact from 'google-map-react';

const KMLMapContainer = ({ props, onRender }) => {
  const mapRef = useRef(null);
  const mapsApiRef = useRef(null);
  const { REACT_APP_GOOGLE_MAPS_API_KEY, REACT_APP_GOOGLE_MAPS_ID } = process.env;
  const { _id, title } = props;
  return (
    <div
      style={{
        position: 'absolute',
        zIndex: 0,
        marginTop: 'auto',
        width: '95%',
        height: '95%',
      }}
    >
      <h1>Job Name:{title}</h1>
      <div style={{ height: '90%', width: '100%' }} ref={mapRef}>
        <GoogleMapReact
          id={_id}
          bootstrapURLKeys={{
            key: REACT_APP_GOOGLE_MAPS_API_KEY,
          }}
          defaultCenter={{
            lng: -96.8172843880738,
            lat: 33.09087757313318,
          }}
          defaultZoom={12}
          yesIWantToUseGoogleMapApiInternals
          options={{
            mapId: REACT_APP_GOOGLE_MAPS_ID,
          }}
          onGoogleApiLoaded={({ map, maps }) => {
            mapRef.current = map;
            mapsApiRef.current = maps;
            if (onRender) {
              onRender(map, maps, props);
            }
            maps.event.trigger(map, 'resize');
          }}
        />
      </div>
    </div>
  );
};

export default KMLMapContainer;
